export const MEMBER_GROUP_LABELS: Record<string, string> = {
  USER: 'User',
  CREATOR_ONLINE: 'Online Creator',
  CREATOR_STUDIO: 'Studio Creator',
};

export const STUDIO_BRANCH_LABELS: Record<string, string> = {
  DANCE: 'Dance Creator',
  NPC: 'NPC Creator',
};

export const MEMBER_ROLE_LABELS: Record<string, string> = {
  USER: 'User',
  CREATOR: 'Online Creator',
  STUDIO_CREATOR: 'Studio Creator',
  ADMIN: 'Admin',
  MOD: 'Mod',
  AGENCY: 'Agency',
};
